import styled from 'styled-components'
export const Container = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 40px;
  width: 100%;
  background-color: #FFFFFF;
  ${({ hasBorder }) => hasBorder && 'border-radius: 16px;  border: 1px solid #DADADA;'}
  ${({ hasTopBorder }) => hasTopBorder && 'border-top: 1px solid #DADADA;'}
  ${({ isEditable }) => !isEditable && 'padding-top: 24px;'}
`
export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${({ separator }) => separator && 'gap: 4px; border-right: 1px solid #DADADA; padding-right: 24px;'}
`
export const SideIcon = styled.div`
  margin-right: -24px;
`
export const Title = styled.div`
  color: #444444;
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
`
export const Subtitle = styled.div`
  color: #555555;
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: 400;
  line-height: 19.2px;
`
export const EditableArea = styled.div`
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid #028BB7;
  margin-left: auto;
  width: 40px;
  height: 40px;
  padding: 8px 8px;
  justify-content: center;
  align-items: center;
  svg {
    margin-top: -2px;
  }
`
export const Field = styled.div`
  strong {
    font-weight: 600;
    font-family: 'Open Sans';
  }
  color: #555;
  font-family: 'Open Sans';
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
`

export const Button = styled.a`
  cursor: pointer;
`
